import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import MediaPlayer from "./MediaPlayer";
import { useTranslation } from "../hooks/useTranslation";

/**
 * Janela popup que embute o `MediaPlayer` para pré-visualização de áudios e
 * vídeos. Usada pelo `FileDownload` quando o arquivo é de mídia, mas pode
 * ser reutilizada onde for necessário um preview "modal" do mesmo player.
 *
 * Props relevantes (todas opcionais exceto `open`/`onClose`):
 *   - `file` ({ token, filename }) ou `token`/`filename` separados.
 *   - `serviceName` (default: "DOCUMENT_CREATION").
 *   - `mediaType` ("audio" | "video"); se omitido, é inferido do filename.
 *   - `playerRef` repassado ao MediaPlayer interno para permitir controle
 *     externo (seek/play/etc.).
 *   - `onTimeUpdate` callback chamado pelo player a cada 100ms enquanto
 *     reproduz.
 */
const MediaPreviewDialog = ({
  open,
  onClose,
  file,
  token,
  filename,
  serviceName = "DOCUMENT_CREATION",
  mediaType,
  autoPlay = false,
  playerRef,
  onTimeUpdate,
  onDownload,
}) => {
  const { t } = useTranslation("common");

  const resolvedFilename = file?.filename || filename || "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="ikaro-media-preview-dialog"
      maxWidth="md"
      fullWidth
      keepMounted={false}
    >
      <DialogTitle className="ikaro-media-preview-dialog__title">
        {resolvedFilename || t("mediaPlayer.previewTitle")}
      </DialogTitle>
      <DialogContent className="ikaro-media-preview-dialog__content">
        {open && (
          <MediaPlayer
            ref={playerRef}
            file={file}
            token={token}
            filename={filename}
            serviceName={serviceName}
            mediaType={mediaType}
            autoPlay={autoPlay}
            onTimeUpdate={onTimeUpdate}
          />
        )}
      </DialogContent>
      <DialogActions className="ikaro-media-preview-dialog__actions">
        {onDownload && (
          <Button
            onClick={onDownload}
            startIcon={<GetApp />}
            variant="outlined"
          >
            {t("filePreview.downloadFile")}
          </Button>
        )}
        <Button onClick={onClose}>{t("close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MediaPreviewDialog;
